export default __webpack_public_path__ + "static/media/hubspot.6216c572.svg";